import { NgModule, NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Ng9RutModule } from 'ng9-rut';
import { MDBBootstrapModulesPro, ToastModule } from 'ng-uikit-pro-standard';
import { SharedModule } from 'src/app/shared/shared.module';
import { SharedViewsModule } from '../shared/shared-views.module';
import { TipoMovimientoComponent } from './tipo-movimiento/tipo-movimiento.component';
import { ModalAddEditComponent } from './tipo-movimiento/modal-add-edit/modal-add-edit.component';
import { ProductosComponent } from './productos/productos.component';
import { ProductoModalAddEditComponent } from './productos/modal-add-edit/modal-add-edit.component';
import { ProductosModalResumenComponent } from './productos/modal-resumen/modal-resumen.component';
import { ProductoModalDatosComercialesComponent } from './productos/modal-datos-comerciales/modal-datos-comerciales.component';
import { ProductoModalVolumenPesoComponent } from './productos/modal-volumen-peso/modal-volumen-peso.component';
import { ProductoModalPrecioCostoComponent } from './productos/modal-precio-costo/modal-precio-costo.component';
import { ProductoModalSeleccionarImpuestoComponent } from './productos/modal-seleccionar-impuesto/modal-seleccionar-impuesto.component';
import { ProductosFormDatosComercialesComponent } from './productos/form-datos-comerciales/form-datos-comerciales.component';
import { ProductosFormAddEditComponent } from './productos/form-add-edit/form-add-edit.component';
import { ProductoModalAddComponent } from './productos/modal-add/modal-add.component';
import { ProductoModalStockComponent } from './productos/modal-stock/modal-stock.component';
import { RubroComponent } from './rubro/rubro.component';
import { RubroModalAddEditComponent } from './rubro/modal-add-edit/modal-add-edit.component';
import { FamiliaComponent } from './familia/familia.component';
import { FamiliaModalAddEditComponent } from './familia/modal-add-edit/modal-add-edit.component';
import { UnidadMedidaComponent } from './unidadmedida/unidadmedida.component';
import { UnidadMedidaModalAddEditComponent } from './unidadmedida/modal-add-edit/modal-add-edit.component';
import { MotivosDevolucionComponent } from './motivos-devolucion/motivos-devolucion.component';
import { MotivoDevolucionModalAddEditComponent } from './motivos-devolucion/modal-add-edit/modal-add-edit.component'
import { ChoferComponent } from "./chofer/chofer.component";

import { MaestroEquivalenciasComponent } from "./maestro-equivalencias/maestro-equivalencias.component";
import { ModalAddEditProductoEquivalenciaComponent } from './maestro-equivalencias/modal-add-edit/modal-add-edit.component';
import { VendedorRubroComponent } from "./vendedor-rubro/vendedor-rubro.component";
import { ProveedorComponent } from "./proveedor/proveedor.component";
import { AddEditProveedorComponent } from './proveedor/add-edit-proveedor/add-edit-proveedor.component';
import { TraspasoMasivoClienteComponent } from "./traspaso-masivo-cliente/traspaso-masivo-cliente.component";
import { ModalMarcadoMasivoComponent } from './traspaso-masivo-cliente/modal-marcado-masivo/modal-marcado-masivo.component';
import { ModalAsignarClienteComponent } from './traspaso-masivo-cliente/modal-asignar-cliente/modal-asignar-cliente.component';
import { ModalGenerarIptComponent } from './traspaso-masivo-cliente/modal-generar-ipt/modal-generar-ipt.component';
import { ModalTransferenciaClienteVendedorComponent } from './traspaso-masivo-cliente/modal-transferencia-cliente-vendedor/modal-transferencia-cliente-vendedor.component';
import { FormStockComponent } from './productos/form-stock/form-stock.component';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { CheckinCheckoutComponent } from './checkin-checkout/checkin-checkout.component';
import { ListaAuditoriaComponent } from "../configuracion-sistema/auditoria/lista-auditoria/lista-auditoria.component";
import { ConfiguracionSistemaModule } from "../configuracion-sistema/configuracion-sistema.module";
import { CamionComponent } from './camion/camion.component';
import { MixturaComponent } from './mixtura/mixtura.component';
import { AgregarEditarMixturaComponent } from './mixtura/agregar-editar-mixtura/agregar-editar-mixtura.component';

@NgModule({
  declarations: [
    TipoMovimientoComponent,
    ModalAddEditComponent,
    ProductosComponent,
    ProductoModalAddEditComponent,
    ProductosModalResumenComponent,
    ProductoModalDatosComercialesComponent,
    ProductoModalVolumenPesoComponent,
    ProductoModalPrecioCostoComponent,
    ProductoModalSeleccionarImpuestoComponent,
    ProductosFormDatosComercialesComponent,
    ProductosFormAddEditComponent,
    ProductoModalAddComponent,
    ProductoModalStockComponent,
    RubroComponent,
    RubroModalAddEditComponent,
    FamiliaComponent,
    FamiliaModalAddEditComponent,
    UnidadMedidaComponent,
    UnidadMedidaModalAddEditComponent,
    MaestroEquivalenciasComponent,
    ModalAddEditProductoEquivalenciaComponent,
    VendedorRubroComponent,
    ProveedorComponent,
    AddEditProveedorComponent,
    TraspasoMasivoClienteComponent,
    ModalMarcadoMasivoComponent,
    ModalAsignarClienteComponent,
    ModalGenerarIptComponent,
    ModalTransferenciaClienteVendedorComponent,
    MotivosDevolucionComponent,
    MotivoDevolucionModalAddEditComponent,
    FormStockComponent,
    ChoferComponent,
    CheckinCheckoutComponent,
    CamionComponent,
    MixturaComponent,
    AgregarEditarMixturaComponent,
  ],
  imports: [
    CommonModule,
    ToastModule.forRoot(),
    MDBBootstrapModulesPro.forRoot(),
    Ng9RutModule,
    FormsModule,
    ReactiveFormsModule,
    SharedViewsModule,
    SharedModule,
    MatButtonModule,
    MatIconModule,
    InfiniteScrollModule,
    ConfiguracionSistemaModule,
    ScrollingModule
  ],
  exports: [
    TipoMovimientoComponent,
    ProductosComponent
  ],
  schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA]
})
export class MantenedoresModule { }
